
































































































import {computed, ComputedRef, defineComponent, onUnmounted, reactive} from "@vue/composition-api"
import {Environment, getEnvironments, userRoles} from "@/data/repos/environments"
import Status from "@/components/Status.vue"
import Loading from "@/components/Loading.vue"
import BaseLayout from "@/components/layout/BaseLayout.vue"
import EnvConfigDialog from "@/components/EnvConfigDialog.vue"

function filterEnvironments(envList: Environment[], s: string): Environment[] {
  if (!s || s.length === 0) return envList
  return envList.filter((v) => {
    if (s.startsWith("wave:")) {
      console.info("s:", s)
      console.info("wave:", v.wave)
      console.info("cmp:", s.substring("wave:".length, s.length))
      return v.wave === s.substring("wave:".length, s.length)
    }
    if (s.startsWith("\"") && s.endsWith("\"") && s.length > 2) {
      return v.searchString.toLowerCase().indexOf(s.toLowerCase()) !== -1
    }
    for (const word of s.split(" ").filter(v => v.length)) {
      if (v.searchString.toLowerCase().indexOf(word.toLowerCase()) === -1) {
        return false
      }
    }
    return true
  })
}

export default defineComponent({
  components: {EnvConfigDialog, BaseLayout, Loading, Status},
  setup() {
    const state = reactive({
      environmentsRaw: [] as Environment[],
      environments: undefined as undefined|ComputedRef,
      search: "",
      clientCount: 0,
      micadCount: 0,
      zohoCount: 0,
      displayEnvDialog: false,
      isAdmin: false,
    })
    state.environments = computed(() => filterEnvironments(state.environmentsRaw, state.search))

    async function updateEnvironments() {
      state.environmentsRaw = await getEnvironments()
      state.clientCount = state.environmentsRaw.reduce((prev, curr) => prev + (curr.id.startsWith("client-") ? 1 : 0), 0)
      state.micadCount = state.environmentsRaw.reduce((prev, curr) => prev + (curr.id.startsWith("micad-") ? 1 : 0), 0)
      state.zohoCount = state.environmentsRaw.reduce((prev, curr) => prev + (curr.id.startsWith("zoho-") ? 1 : 0), 0)
    }

    async function showEnvDialog() {
      state.displayEnvDialog = true
    }

    setTimeout(async() => {
      const roles = (await userRoles())?.roleNames || []
      state.isAdmin = roles.includes("DCAdmin")
    }, 0)

    updateEnvironments()
    const updateTimer = setInterval(() => updateEnvironments(), 30 * 1000)
    onUnmounted(() => clearInterval(updateTimer))
    return {state, showEnvDialog}
  },
})
